import useAuth from '@modules/AuthModule/hooks/useAuth';
import {
  HELP_CENTER_BUTTON_STORE,
  HELP_CENTER_STORE,
  HELP_CENTER_TOPIC_STORE,
  HelpCenterLoader,
  IHelpCenterSettings,
} from '@servicetitan/help-center';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import environment from '@lib/environment';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';

const { API_URL, HELP_CENTER_URL } = environment;

const AUTH_URL = API_URL + '/v1/help-center/auth';

export const HelpCenterMfeLoader = observer(() => {
  const { [FeatureFlagKeys.featureHelpCenter]: featureHelpCenter } =
    useFeatureFlags();

  const [helpCenterStore, helpCenterButtonStore, helpCenterTopicStore] =
    useDependencies(
      HELP_CENTER_STORE,
      HELP_CENTER_BUTTON_STORE,
      HELP_CENTER_TOPIC_STORE,
    );

  useEffect(() => {
    helpCenterButtonStore.setLabel('Help Center.');
  }, [helpCenterButtonStore]);

  const { user, token } = useAuth();

  const settings = useMemo(
    (): IHelpCenterSettings => ({
      initialScreen: helpCenterStore.initialScreen,
      isOpen: helpCenterButtonStore.isOpen,
      location: helpCenterTopicStore.location?.pathname ?? '',
      serviceUrl: HELP_CENTER_URL,
      authUrl: AUTH_URL,
      instance: 'CCPro',
      tenantName: '',
      userName: user?.email ?? '',
      name: user?.name ?? '',
      phone: '',
      email: user?.email ?? '',
      mobilePhone: '',
      topic: '',
      authUrlHeaders: { Authorization: `Bearer ${token}` },
      tenantIds: user?.org.tenants.map((t) => Number(t.id)) ?? [],
    }),
    [
      helpCenterStore.initialScreen,
      helpCenterButtonStore.isOpen,
      helpCenterTopicStore.location?.pathname,
      user,
      token,
    ],
  );

  if (!featureHelpCenter) {
    return null;
  }

  return (
    <div>
      <HelpCenterLoader settings={settings} />
    </div>
  );
});
